import React from 'react';
import classNames from 'classnames';
import { Spinner } from 'react-bootstrap';
import text from '../../../../text';
var WithLoader = function(param) {
    var children = param.children, _param_hasCharges = param.hasCharges, hasCharges = _param_hasCharges === void 0 ? true : _param_hasCharges, className = param.className, _param_showLoaderText = param.showLoaderText, showLoaderText = _param_showLoaderText === void 0 ? true : _param_showLoaderText, _param_fullWidth = param.fullWidth, fullWidth = _param_fullWidth === void 0 ? true : _param_fullWidth;
    if (hasCharges) return children;
    return /*#__PURE__*/ React.createElement("div", {
        className: classNames('d-flex flex-row align-items-center', className, {
            'flex-fill': fullWidth
        })
    }, /*#__PURE__*/ React.createElement(Spinner, {
        animation: "border",
        className: "size-12 grey-3"
    }), showLoaderText && /*#__PURE__*/ React.createElement("p", {
        className: "mb-0 ml-1 font-12 grey-3"
    }, text('fetching')));
};
export default WithLoader;
